"use strict";

var getRelevantWords = require("../stringProcessing/relevantWords").getRelevantWords;
/**
 * Retrieves the relevant words from the given paper.
 *
 * @param {Paper} paper The paper to determine the relevant words of.
 * @returns {WordCombination[]} Relevant words for this paper, filtered and sorted.
 */
function relevantWords(paper) {
  return getRelevantWords(paper.getText(), paper.getLocale());
}
module.exports = relevantWords;
//# sourceMappingURL=relevantWords.js.map
//# sourceMappingURL=relevantWords.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/yoastseo/js/researches/relevantWords.js
// module id = 461
// module chunks = 0